var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8416 4.04866C18.7585 3.71356 18.3392 3.60001 18.095 3.84419L15.3355 6.60364L12.8166 6.18394L12.3969 3.66495L15.1563 0.905498C15.402 0.659834 15.2836 0.24124 14.9463 0.157373C13.188 -0.278291 11.252 0.191142 9.87787 1.56493C8.40685 3.03595 8.00199 5.16825 8.61429 7.02743L0.695522 14.9462C-0.231841 15.8736 -0.231841 17.3772 0.695522 18.3046C1.62289 19.232 3.12656 19.232 4.05392 18.3046L11.966 10.3925C13.8259 11.0126 15.9542 10.6033 17.4348 9.12263C18.8105 7.74698 19.2792 5.80802 18.8416 4.04866ZM2.37509 17.5157C1.88339 17.5157 1.48447 17.1167 1.48447 16.625C1.48447 16.133 1.88339 15.7344 2.37509 15.7344C2.86679 15.7344 3.26572 16.133 3.26572 16.625C3.26572 17.1167 2.86679 17.5157 2.37509 17.5157Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.d0f6ded3a3a5b7a4e1080bc80b320015.svg";
export { ForwardRef as ReactComponent };